import { LitElement, html, nothing, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { makeCustomEvent, EVENT } from '../util/events';
import { consume } from '@lit/context';
import { breakpointContext } from '../contexts/breakpoint';
import { BREAKPOINT } from '../util/breakpoints';
import { classMap } from 'lit/directives/class-map.js';

@customElement('rq-back-button')
export class BackButton extends LitElement {
    static styles = css`
        .content {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            margin: auto;
            gap: 4px;
        }
        .icon {
            display: flex;
            justify-content: end;
        }
        .icon-padding {
            padding-top: 1px;
        }
    `;
    @property({ type: Boolean })
    disabled: boolean = false;

    @property()
    analyticsid: string = '';

    @consume({ context: breakpointContext, subscribe: true })
    breakpoint!: BREAKPOINT;

    get isMobile() {
        return this.breakpoint === BREAKPOINT.PHONE || this.breakpoint === BREAKPOINT.TABLET;
    }

    render() {
        return html`<lh-button
            .disabled=${this.disabled}
            analytics-id=${this.analyticsid || nothing}
            full-width
            @click=${() => this.dispatchEvent(makeCustomEvent(EVENT.PREVIOUS_STEP))}
            variant="text"
        >
            <div class="content">
                <div class=${classMap({ icon: true, 'icon-padding': !this.isMobile })}>
                    <lh-icon size="sm" name="caret-left"> </lh-icon>
                </div>
                <div>Back</div>
                <div></div>
            </div>
        </lh-button>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'rq-back-button': BackButton;
    }
}
